import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class VendorTypeService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/vendor_types`);
  }

  getVendorTypes() {
    const url = `${environment.apiBaseUrl}/vendor_types`;
    return this.http.get<any>(url);
  }
}
